import React, { useState } from 'react'
import _ from 'lodash'
import { useSelector } from 'react-redux'
import AdditionDeductionFields from './commonComponents/AdditionDeductionFields'


const AdditionDeductionMechLevel=({className='',invoiceItemIndex,lineItemIndex,index,onUpdate,onSave,disabled,...rest})=> {
const additions=useSelector(state=>state.DescriptionOfMerchandise?.entrySummaryInvoices[invoiceItemIndex]?.merchandiseLineItems[lineItemIndex]?.merchandiseDuties[index]?.additions)
const deletions=useSelector(state=>state.DescriptionOfMerchandise?.entrySummaryInvoices[invoiceItemIndex]?.merchandiseLineItems[lineItemIndex]?.merchandiseDuties[index]?.deletions)
 const [isLoading,setIsLoading]=useState(false)
     const onUpdateData=(value,objectKey,field)=>{
      onUpdate(lineItemIndex,invoiceItemIndex,index,objectKey,field,value.replace(/[^\d.-]/g, ""))
     }
     const onSaveData=(value,objectKey,field)=>{
      setIsLoading(true)
      onSave({lineItemIndex,invoiceItemIndex,dutyIndex:index,field,newxValue:parseFloat(value || 0.0).toFixed(2)},()=>{
        setIsLoading(false)

      })
     }

   
    return (
       <AdditionDeductionFields id={`${lineItemIndex}-${index}`} isLoading={isLoading} {...rest}  onSave={onSaveData} onUpdate={onUpdateData} additions={additions} deletions={deletions} className={className} disabled={disabled} />
      
    )
  }
export default AdditionDeductionMechLevel